import { render, staticRenderFns } from "./pureText.vue?vue&type=template&id=1b96706c&scoped=true&"
import script from "./pureText.vue?vue&type=script&lang=js&"
export * from "./pureText.vue?vue&type=script&lang=js&"
import style0 from "./pureText.vue?vue&type=style&index=0&id=1b96706c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b96706c",
  null
  
)

export default component.exports